import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSevereIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			rx: 8,
			fill: "#C84A2B",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_30074_6141)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M8.00049 9.55554H8.00389",
					stroke: "#C84A2B",
					strokeWidth: 1.06667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.00049 6.44458V8.00014",
					stroke: "#C84A2B",
					strokeWidth: 1.06667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.28871 4.11127C9.49497 4.11131 9.69277 4.19328 9.83859 4.33916L11.6617 6.16227C11.8076 6.30809 11.8896 6.50589 11.8896 6.71216V9.28816C11.8896 9.49442 11.8076 9.69222 11.6617 9.83804L9.83859 11.6612C9.69277 11.807 9.49497 11.889 9.28871 11.889H6.71271C6.50644 11.889 6.30864 11.807 6.16282 11.6612L4.33971 9.83804C4.19383 9.69222 4.11186 9.49442 4.11182 9.28816V6.71216C4.11186 6.50589 4.19383 6.30809 4.33971 6.16227L6.16282 4.33916C6.30864 4.19328 6.50644 4.11131 6.71271 4.11127H9.28871Z",
					stroke: "#C84A2B",
					strokeWidth: 1.06667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_30074_6141",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 9.33333,
				height: 9.33333,
				fill: "white",
				transform: "translate(3.3335 3.33331)"
			})
		}) })
	]
});
export default SvgSevereIcon;
